import UploadFileContainer from './containers/UploadFileContainer'

export default UploadFileContainer
